import httpService from 'services/httpService.js';
import * as actionTypes from "./ActionTypes";
import fileDownload from "js-file-download";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import log from "loglevel";

export const otherLabsLoaded = (data) => {
  return {
    type: actionTypes.LOAD_ALL_OTHERLABS,
    payload: data,
  };
};

export const deleteLab = (data) => {
  return {
    type: actionTypes.DELETE_OTHERLAB,
    payload: data,
  };
};

export const updateLab = (data) => {
  return {
    type: actionTypes.UPDATE_OTHERLAB,
    payload: data,
  };
};

export const createLab = (data) => {
  return {
    type: actionTypes.CREATE_OTHERLAB,
    payload: data,
  };
};

export const loadOtherLabs = (courseId) => {
  return async (dispatch) => {

    try {
      // log.log("Hello Axios", httpService.defaults);
      const response = await httpService.get(`/otherlabs/${courseId}/`);
      log.log(response)
      dispatch(otherLabsLoaded(response.data));
    } catch (err) {
      log.log(err);
    }
  };
};

export const deleteOtherLab = (courseId, otherLabId) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      const response = await httpService.delete(
        `/otherlabs/${courseId}/${otherLabId}/`
      );
      log.log(response);
      log.log(otherLabId);
      dispatch(deleteLab(otherLabId));
    } catch (err) {
      log.log(err);
    }
  };
};

export const createOtherLab = (courseId, formdata) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", formdata);
      const response = await httpService.post(`/otherlabs/${courseId}/`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      log.log(response);
      dispatch(createLab(response.data));
      return true;
    } catch (err) {
      log.log(err);
    }
  };
};

export const updateOtherLab = (courseId, formdata, otherLabId) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      const response = await httpService.put(
        `/otherlabs/${courseId}/${otherLabId}/`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      log.log(response);
      dispatch(updateLab(response.data));
      return true;
    } catch (err) {
      log.log(err);
    }
  };
};

export const sampleFileDownload = () => {
  return async (dispatch) => {
    try {
      const response = await httpService.get(`/otherlabs/sample_file_download/`, {
        responseType: "blob",
      });
      fileDownload(response.data, "sample-other-lab.odt");
    } catch (err) {
      log.log(err);
    }
  };
};

// To save the question responses of the students - integrated with Labs
export const addQuestionResponsesRequest = async (courseId, question, optId, ansText, qrId, check) => {
  try {
    if (question.question_type === "S" || question.question_type === "M") {
      if (optId !== null) {
        const response = await httpService.post(
          `/otherlabs/questions/${question.id}/responses/?format=json`,
          qrId ? { question: question.id, response_options_ids: [optId], is_checked: check, id: qrId} : { question: question.id, response_options_ids: [optId], check: check},
        );
        // log.log("Response for addQuestionResponsesRequest", response);
        displayGlobalMessage("Response has been recorded Successfully", "success");
        return response.data;
      }
    }
    else if (question.question_type === "D" || question.question_type === "F" || question.question_type === "N") {
      log.log(" qrId  : ",qrId)
      const response = await httpService.post(
        `/otherlabs/questions/${question.id}/responses/?format=json`,
        qrId ? { question: question.id, response_text: ansText, id: qrId} : { question: question.id, response_text:ansText},
      );
      // log.log("Response for addQuestionResponsesRequest", response);
      displayGlobalMessage("Response has been added Successfully", "success");
      return response.data;
    }
  } catch (error) {
    log.log(error);
    displayGlobalMessage("Response Addition Failed.", "error");
    throw error;
  }
};

// To save the remarks for the questions - integrated with Labs
export const addRemarkRequest = async (question, qrId, remark) => {
  try {
    if (qrId !== null) {
      const response = await httpService.post(
        `/otherlabs/questions/${question.id}/responses/?format=json`,
        { question: question.id, id: qrId, remark: remark },
      );
      // log.log("Response for addQuestionResponsesRequest", response);
      displayGlobalMessage("Remark has been recorded Successfully", "success");
      return response.data;
    }
  } catch (error) {
    log.log(error);
    displayGlobalMessage("Remark Addition Failed.", "error");
    throw error;
  }
};

export const addScoredMarksRequest = async (question, qrId, scored_marks) => {
  try {
    if (qrId !== null) {
      const response = await httpService.post(
        `/otherlabs/questions/${question.id}/responses/?format=json`,
        { question: question.id, id: qrId, scored_marks: scored_marks },
      );
      // log.log("Response for addQuestionResponsesRequest", response);
      displayGlobalMessage("Marks recorded Successfully", "success");
      return response.data;
    }
  } catch (error) {
    log.log(error);
    displayGlobalMessage("Marks Addition Failed.", "error");
    throw error;
  }
};

export const autoCalculateScoredMarksRequest = async (question, qrId, scored_marks) => {
  log.log("inside AutoCalculateMarksApiCall",question,qrId,scored_marks)
  try {
    if (qrId !== null) {
      const response = await httpService.post(
        `/otherlabs/questions/${question.id}/responses/?format=json`,
        { question: question.id, id: qrId, scored_marks: scored_marks },
      );
      return response.data;
    }
  } catch (error) {
    log.log(error);
    displayGlobalMessage("Auto-Marks Calculation Failed.", "error");
    throw error;
  }
};

// To upload required files for the activity - integrated with Labs
export const uploadRequiredFilesRequest = async (other_activity, formData) => {
  try {
    const response = await httpService.post(
      `/otherlabs/uploadfiles/${other_activity.id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    log.log("Response for Upload Required Files:", response)
    displayGlobalMessage("Response has been added Successfully", "success");
    return response.data;
  } catch (error) {
    log.log(error);
    displayGlobalMessage("File Upload Failed", "error");
    throw error;
  }
};

// export const calculateScoreRequest = async () => {
//   try {

//   } catch {

//   }
// };